const SUNAT_API_URL = process.env.REACT_APP_SUNAT_API_URL || '/php-api/grenderphp/generar_comprobante.php';

export const ApiSunatService = {
    generarComprobante: async (payload) => {
        const response = await fetch(SUNAT_API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        const rawResponse = await response.text();
        let data = null;
        let parseError = null;

        try {
            data = rawResponse ? JSON.parse(rawResponse) : null;
        } catch (error) {
            parseError = error;
        }

        if (parseError) {
            // Ayuda para depurar cuando PHP devuelve HTML (warnings/fatals) en vez de JSON.
            console.group('SUNAT API - Respuesta no JSON');
            console.error('Error parseando JSON:', parseError);
            console.info('Endpoint:', SUNAT_API_URL);
            console.info('Status HTTP:', response.status);
            console.info('Payload enviado:', payload);
            console.info('Respuesta cruda (primeros 1000 chars):', rawResponse?.slice(0, 1000));
            console.groupEnd();

            const hint = rawResponse?.includes('<')
                ? 'El backend PHP devolvio HTML (warning/fatal). Revise logs de PHP/Apache y la respuesta en consola del navegador.'
                : 'El backend no devolvio JSON valido.';

            throw new Error(`Respuesta invalida del servidor SUNAT. ${hint}`);
        }

        if (!response.ok || data?.success === false) {
            const message = data?.error || data?.mensaje || 'No se pudo generar el comprobante en SUNAT';
            console.group('SUNAT API - Error de negocio/HTTP');
            console.info('Endpoint:', SUNAT_API_URL);
            console.info('Status HTTP:', response.status);
            console.info('Payload enviado:', payload);
            console.info('Respuesta JSON:', data);
            console.groupEnd();
            throw new Error(message);
        }

        console.group('SUNAT API - Comprobante generado');
        console.info('Endpoint:', SUNAT_API_URL);
        console.info('Status HTTP:', response.status);
        console.info('Payload enviado:', payload);
        console.info('Respuesta JSON:', data);
        console.groupEnd();

        return data;
    }
};
